import {Route} from 'react-router';
import authenticationService from '../service/authentication';

export default class AuthenticatedRoute extends Route {
  static defaultProps = {
    onEnter: (nextState, replace) => {
      if (authenticationService.isAuthenticated) {
        return;
      }

      return replace('/login');
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/interactive-solutions/authentication/router/authenticated.js
 **/